export default {
  LocationUseErrorSetting:
    "L'accès au service de localisation est obligatoire pour déterminer la valeur automatiquement. Veuillez l'autoriser depuis les réglages",
  OpenSettings: 'Accéder aux réglages',
  localisationAlertPermissionsTitle: 'Pouvons nous accéder au service de localisation',
  localisationPressinAlertPermissionsDesc: 'Il est utilisé pour estimer automatiquement la pression atmosphérique.',
  map_location_unknow_error: "Le GPS n'a pas donné de résultat ou a mis trop de temps à répondre",
  //temp ext
  click_temp_base_ext: 'Cliquer pour choisir la température',
  click_temp_base_ext_sub: 'Code postal : ',
  temp_base_ext_france: 'Disponible uniquement pour la France',
  temperature_no_data: 'Aucune température trouvé. Veuillez réessayer.',
  tempeature_altitude: 'Votre altitude estimée : '
}
